/* ==========================================================================
   Melt Nook — theme behaviour
   Vanilla JS, no dependencies. Everything degrades gracefully without JS.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.MeltNook && window.MeltNook.routes) || {};
  var strings = (window.MeltNook && window.MeltNook.strings) || {};
  var money = (window.MeltNook && window.MeltNook.moneyFormat) || '${{amount}}';

  /* --- helpers ---------------------------------------------------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = money
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.'));
    return out;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait || 200);
    };
  }

  /* --- overlay + drawers ------------------------------------------------ */
  var overlay = $('[data-overlay]');
  var lastFocused = null;

  function openPanel(id) {
    var panel = document.getElementById(id);
    if (!panel) return;
    lastFocused = document.activeElement;
    $$('[data-panel]').forEach(function (p) { if (p !== panel) p.classList.remove('is-open'); });
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('is-locked');
    var focusable = panel.querySelector('[autofocus], button, a[href], input, select, textarea');
    if (focusable) setTimeout(function () { focusable.focus(); }, 260);
    document.dispatchEvent(new CustomEvent('meltnook:panel:open', { detail: { id: id } }));
  }

  function closePanels() {
    $$('[data-panel]').forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openPanel(opener.getAttribute('data-open'));
      return;
    }
    if (e.target.closest('[data-close]')) {
      e.preventDefault();
      closePanels();
    }
  });

  on(overlay, 'click', closePanels);
  on(document, 'keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  // Trap focus loosely inside an open drawer
  on(document, 'keydown', function (e) {
    if (e.key !== 'Tab') return;
    var panel = $('[data-panel].is-open');
    if (!panel) return;
    var items = $$('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* --- cart ------------------------------------------------------------- */
  var cartDrawerId = 'shopify-section-cart-drawer';

  function refreshCartSections(sections) {
    if (sections && sections['cart-drawer']) {
      var host = document.getElementById(cartDrawerId);
      if (host) {
        var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = parsed.getElementById(cartDrawerId);
        if (fresh) {
          var wasOpen = host.querySelector('[data-panel]') && host.querySelector('[data-panel]').classList.contains('is-open');
          host.innerHTML = fresh.innerHTML;
          if (wasOpen) {
            var panel = host.querySelector('[data-panel]');
            if (panel) { panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); }
          }
        }
      }
    }
    if (sections && sections['main-cart'] && document.getElementById('shopify-section-main-cart')) {
      var cartHost = document.getElementById('shopify-section-main-cart');
      var cartParsed = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
      var freshCart = cartParsed.getElementById('shopify-section-main-cart');
      if (freshCart) cartHost.innerHTML = freshCart.innerHTML;
    }
  }

  function updateCartCount(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function sectionsToRequest() {
    var list = ['cart-drawer'];
    if (document.getElementById('shopify-section-main-cart')) list.push('main-cart');
    return list.join(',');
  }

  function afterCartChange(data) {
    refreshCartSections(data.sections);
    fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart);
        document.dispatchEvent(new CustomEvent('meltnook:cart:updated', { detail: { cart: cart } }));
      });
  }

  // Add to cart (product forms + quick add)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    if (document.documentElement.getAttribute('data-cart-type') !== 'drawer') return;
    e.preventDefault();

    var btn = form.querySelector('[data-add-btn]');
    var label = btn ? btn.querySelector('[data-add-label]') : null;
    var original = label ? label.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); }
    if (label) label.textContent = strings.adding || 'Adding…';

    var fd = new FormData(form);
    fd.append('sections', sectionsToRequest());
    fd.append('sections_url', window.location.pathname);

    fetch(routes.cart_add_url ? routes.cart_add_url + '.js' : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          var err = form.querySelector('[data-form-error]');
          if (err) { err.textContent = data.description || data.message; err.hidden = false; }
          return;
        }
        afterCartChange(data);
        openPanel('cart-drawer');
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-disabled');
        if (label) label.textContent = original;
      });
  });

  // Quantity + remove inside cart
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(parseInt(input.getAttribute('min') || '0', 10), next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-cart-remove'), 0, remove.closest('.line-item'));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-cart-qty'), input.value, input.closest('.line-item'));
  });

  function changeLine(line, quantity, el) {
    if (el) el.style.opacity = '.45';
    cartRequest(routes.cart_change_url ? routes.cart_change_url + '.js' : '/cart/change.js', {
      line: parseInt(line, 10),
      quantity: parseInt(quantity, 10),
      sections: sectionsToRequest().split(','),
      sections_url: window.location.pathname
    }).then(afterCartChange);
  }

  // Cart note
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    cartRequest('/cart/update.js', { note: note.value, sections: [] });
  });

  /* --- variant picker ---------------------------------------------------- */
  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      if (picker.dataset.bound) return;
      picker.dataset.bound = '1';

      var scope = picker.closest('[data-product-root]') || document;
      var dataEl = $('[data-variant-json]', scope);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);

      picker.addEventListener('change', function () {
        var chosen = $$('input:checked, select', picker).map(function (el) { return el.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });

        var idInput = $('[data-variant-id]', scope);
        var addBtn = $('[data-add-btn]', scope);
        var addLabel = $('[data-add-label]', scope);
        // The sticky bar lives outside the product root, so refresh it too
        var priceEls = $$('[data-price-block]', scope).concat($$('[data-sticky-buy] [data-price-block]'));
        var stickyBtn = $('[data-sticky-buy] .btn');

        if (!match) {
          if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); }
          if (addLabel) addLabel.textContent = strings.unavailable || 'Unavailable';
          return;
        }

        if (idInput) idInput.value = match.id;
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }

        var label = match.available
          ? strings.add_to_cart || 'Add to cart'
          : strings.sold_out || 'Sold out';

        if (addBtn && addLabel) {
          if (match.available) addBtn.removeAttribute('aria-disabled');
          else addBtn.setAttribute('aria-disabled', 'true');
          addLabel.textContent = label;
        }
        if (stickyBtn) {
          if (match.available) stickyBtn.removeAttribute('aria-disabled');
          else stickyBtn.setAttribute('aria-disabled', 'true');
          stickyBtn.textContent = label;
        }

        priceEls.forEach(function (priceEl) {
          var html = '<span class="price__now">' + formatMoney(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html = '<span class="price__was">' + formatMoney(match.compare_at_price) + '</span>' + html;
            priceEl.classList.add('price--sale');
          } else {
            priceEl.classList.remove('price--sale');
          }
          priceEl.innerHTML = html;
        });

        // swap gallery to the variant image
        if (match.featured_media_id) {
          var thumb = $('[data-thumb="' + match.featured_media_id + '"]', scope);
          if (thumb) thumb.click();
        }

        $$('[data-swatch-label]', picker).forEach(function (label) {
          var input = label.querySelector('input');
          if (input) label.classList.toggle('is-selected', input.checked);
        });
      });
    });
  }

  /* --- bundle tiers ------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var tier = e.target.closest('[data-offer-tier]');
    if (!tier) return;
    var scope = tier.closest('[data-product-root]') || document;
    var qtyInput = $('input[name="quantity"]', scope);
    if (qtyInput) {
      qtyInput.value = tier.value;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* --- gallery ----------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var scope = thumb.closest('[data-product-root]') || document;
    var stage = $('[data-gallery-stage]', scope);
    var id = thumb.getAttribute('data-thumb');
    if (stage) {
      $$('[data-slide]', stage).forEach(function (slide) {
        var active = slide.getAttribute('data-slide') === id;
        slide.classList.toggle('is-active', active);
        var video = slide.querySelector('video');
        if (video && !active) video.pause();
      });
    }
    $$('[data-thumb]', scope).forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
  });

  /* --- accordion --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-accordion-btn]');
    if (!btn) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var group = btn.closest('[data-accordion-single]');
    if (group && !expanded) {
      $$('[data-accordion-btn]', group).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  });

  /* --- header state ------------------------------------------------------ */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    on(window, 'scroll', onScroll, { passive: true });
  }

  /* --- sticky buy bar ---------------------------------------------------- */
  var stickyBar = $('[data-sticky-buy]');
  var buyAnchor = $('[data-buy-anchor]');
  if (stickyBar && buyAnchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(buyAnchor);
  }

  /* --- reveal on scroll --------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    var watchReveals = function () { $$('.reveal:not(.is-in)').forEach(function (el) { revealObserver.observe(el); }); };
    watchReveals();
    document.addEventListener('shopify:section:load', watchReveals);
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* --- marquee: duplicate content for a seamless loop --------------------- */
  function initMarquees() {
    $$('[data-marquee]').forEach(function (m) {
      var track = m.querySelector('.marquee__track, .announcement__track');
      if (!track || track.dataset.cloned) return;
      track.dataset.cloned = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* --- italic accent in headings: *word* -> <em>word</em> ------------------ */
  function initAccents() {
    $$('[data-accent]:not([data-accent-done])').forEach(function (el) {
      el.setAttribute('data-accent-done', '1');
      if (el.innerHTML.indexOf('*') === -1) return;
      el.innerHTML = el.innerHTML.replace(/\*([^*]+)\*/g, '<em>$1</em>');
    });
  }

  /* --- sparkles ----------------------------------------------------------- */
  function initSparkles() {
    $$('[data-sparkles]:not([data-sparkles-done])').forEach(function (host) {
      host.setAttribute('data-sparkles-done', '1');
      var count = parseInt(host.getAttribute('data-sparkles'), 10) || 7;
      var svg = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0c.6 5.7 4.3 9.4 12 12-7.7 2.6-11.4 6.3-12 12-.6-5.7-4.3-9.4-12-12C7.7 9.4 11.4 5.7 12 0z"/></svg>';
      var frag = '';
      // Deterministic-ish scatter so it looks designed, not random noise
      var spots = [[6, 12], [88, 8], [16, 78], [92, 66], [48, 4], [72, 90], [2, 46], [58, 70], [34, 92]];
      for (var i = 0; i < count; i++) {
        var spot = spots[i % spots.length];
        var size = 9 + ((i * 7) % 14);
        frag += svg.replace('<svg', '<svg style="left:' + spot[0] + '%;top:' + spot[1] + '%;width:' + size + 'px;height:' + size + 'px;animation-delay:' + (i * 0.42).toFixed(2) + 's"');
      }
      host.innerHTML = frag;
    });
  }

  /* --- product recommendations --------------------------------------------- */
  function initRecommendations() {
    $$('[data-recommendations][data-url]').forEach(function (host) {
      var url = host.getAttribute('data-url');
      host.removeAttribute('data-url');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            host.innerHTML = fresh.innerHTML;
            boot();
          }
        })
        .catch(function () {});
    });
  }

  /* --- collection sort ----------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* --- predictive search --------------------------------------------------- */
  var searchInput = $('[data-search-input]');
  var searchResults = $('[data-search-results]');
  if (searchInput && searchResults) {
    var runSearch = debounce(function () {
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      fetch(
        (routes.predictive_search_url || '/search/suggest') +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search'
      )
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var results = parsed.querySelector('[data-predictive-results]');
          searchResults.innerHTML = results ? results.innerHTML : '';
        })
        .catch(function () {});
    }, 260);
    on(searchInput, 'input', runSearch);
  }

  /* --- boot ---------------------------------------------------------------- */
  function boot() {
    // Any Shopify-generated product form counts as an AJAX cart form
    $$('form[action*="/cart/add"]:not([data-cart-form])').forEach(function (f) {
      f.setAttribute('data-cart-form', '');
    });
    initVariantPickers();
    initMarquees();
    initAccents();
    initSparkles();
    initRecommendations();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Theme editor support
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', function (e) {
    var panel = e.target.querySelector('[data-panel][data-editor-open]');
    if (panel) openPanel(panel.id);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-panel][data-editor-open]')) closePanels();
  });

  window.MeltNook = Object.assign(window.MeltNook || {}, {
    openPanel: openPanel,
    closePanels: closePanels,
    formatMoney: formatMoney
  });
})();
